import * as allTypes from 'constants/ActionTypes';
import * as actionTypes from 'modules/interventions/actionTypes';
import { compact } from 'utils/ObjectUtils';

import { createReducer } from 'utils/ReduxUtils';

import * as types from '../../actionTypes';

const initialState = {};

const sortByUserName = (a, b) => a.displayName.localeCompare(b.displayName);
const getUserGroupFromSteps = (state, steps) =>
  steps
    .filter(step => step?.userGroup)
    .reduce(
      (acc, step) => ({ ...acc, [step.userGroup.id]: { ...(state?.[step.userGroup.id] ?? {}), ...step.userGroup } }),
      {}
    );

const userGroupsReducer = (state, { payload: userGroups, meta }) => {
  const { dealerId } = meta;
  const data = userGroups
    .map(userGroup => {
      const { users, links: _links, ...rest } = userGroup;
      const userIds = users?.sort(sortByUserName)?.map(u => u.id) ?? [];
      return { dealerId, ...rest, userIds };
    })
    .reduce((acc, userGroup) => ({ ...acc, [userGroup.id]: userGroup }), {});
  return { ...state, ...data };
};

const userGroupsFromDealerReducer = (state, { payload: dealer }) => {
  if (dealer?.steps) {
    const data = Object.values(dealer.steps).reduce(
      (userGroups, steps) => ({
        ...userGroups,
        ...getUserGroupFromSteps(state, steps),
      }),
      {}
    );
    return { ...state, ...data };
  }
  return state;
};

const userGroupsPerDealersReducer = (state, { payload }) => {
  const data = payload.content.reduce((acc, group) => ({ ...acc, [group.id]: group }), {});
  return { ...state, ...data };
};

const setUserGroupsFromInterventions = (state, { interventions }) => {
  const userGroups = compact(interventions?.content?.map(({ assignedUserGroup }) => assignedUserGroup) ?? []);
  const newUserGroups = userGroups.reduce(
    (newUserGroup, userGroup) => ({
      ...newUserGroup,
      [userGroup.id]: userGroup,
    }),
    {}
  );

  return { ...state, ...newUserGroups };
};

const setUserGroupFromIntervention = (state, { payload: intervention }) => {
  const userGroups = compact([intervention?.assignedUserGroup, intervention?.serviceAdvisorUserGroup]);
  if (userGroups.length > 0) {
    return userGroups.reduce(
      (acc, userGroup) => ({ ...acc, [userGroup.id]: { ...(acc[userGroup.id] ?? {}), ...userGroup } }),
      state
    );
  }
  return state;
};

export default createReducer(initialState, {
  [types.FETCH_USER_GROUPS_SUCCESS]: userGroupsReducer,
  [types.UPDATE_USER_GROUPS_SUCCESS]: userGroupsReducer,
  [allTypes.FETCH_DEALER_SUCCESS]: userGroupsFromDealerReducer,
  [actionTypes.FETCH_INTERVENTION_SUCCESS]: setUserGroupFromIntervention,
  [actionTypes.FETCH_INTERVENTIONS_SUCCESS]: setUserGroupsFromInterventions,
  [types.FETCH_SELECTED_USER_GROUPS_SUCCESS]: userGroupsPerDealersReducer,
});
